// extracted by mini-css-extract-plugin
module.exports = {"cardPreview":"styles_cardPreview__1okC7","cardPreview_number":"styles_cardPreview_number__1v4T_","cardPreview_expInfo":"styles_cardPreview_expInfo__ywTmG"};